import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import IntlComponent from 'axway-react-intl';
import { CodeEditor, ContentLoading, ContentMessage, ErrorPage, PageHeader } from 'axway-react-ui';
import { Button, Glyphicon } from 'react-bootstrap';

class ConfigurationEditorView extends React.Component {
	constructor(props) {
		super(props);
		this.cancel = this.cancel.bind(this);
		this.confirm = this.confirm.bind(this);
		this.confirmAndSave = this.confirmAndSave.bind(this);
		this.onContentChange = this.onContentChange.bind(this);
		IntlComponent.init(this);

		this.configurationContent = this.props.item.content;
		this.originalContent = this.configurationContent;

		this.state = {
			requestSaveConfirmation: false,
			codeNotChanged: true
		};
	}

	componentWillReceiveProps(newProps) {
		this.originalContent = newProps.item.content;
		this.onContentChange(newProps.item && newProps.item.content);
	}

	componentWillUnmount() {
		this.configurationContent = null;
		this.originalContent = null;
	}

	/**
	 * Callback from CodeEditor on change event.
	 */
	onContentChange(content = '') {
		this.configurationContent = content;
		const codeNotChanged = this.originalContent === this.configurationContent;
		// don't set the state unless we know there's a difference
		if (codeNotChanged !== this.state.codeNotChanged) {
			this.setState({
				codeNotChanged
			});
		}
	}

	confirmAndSave() {
		this.setState({
			requestSaveConfirmation: true
		});
	}

	/**
	 * Save the changes to the confiugration.
	 */
	save() {
		const item = {
			...this.props.item,
			content: this.configurationContent
		};
		this.props.onSave(item);
	}

	confirm(confirmed) {
		this.setState({
			requestSaveConfirmation: false
		});
		if (confirmed) {
			this.save();
		}
	}

	/**
	 * Cancel out of the configuration editor.
	 */
	cancel() {
		this.props.onCancel();
	}

	render() {
		const { item } = this.props;

		return (
			<div className="configuration-editor-view">
				<PageHeader>
					<PageHeader.Section align="left">
						<PageHeader.Title>
							<div className="filename-title">
								<Glyphicon glyph=" gg icon-GG-file-empty" />
								<span className="text">{item.name}</span>
							</div>
						</PageHeader.Title>
					</PageHeader.Section>
					<PageHeader.Section align="right">
						<Button
							key="help"
							bsStyle="link"
							className="conf-doc-link"
							href={window.$conf.docConfUrl}
							target="_blank"
							title={this.intl.formatMsg('Learn more about - How to manage Project configuration')}
						>
							<Glyphicon glyph=" gg icon-GG-share" />
							<span>{this.intl.formatMsg('Help')}</span>
						</Button>
						<Button
							key="cancel"
							className="cancel"
							bsSize="large"
							bsStyle="link"
							onClick={this.cancel}
						>
							<span>{this.intl.formatMsg('Cancel')}</span>
						</Button>
						<Button
							key="save"
							className="save"
							bsSize="large"
							bsStyle="primary"
							onClick={this.confirmAndSave}
							disabled={this.state.codeNotChanged}
						>
							<Glyphicon glyph=" gg icon-GG-checkmark-circle" />
							<span>{this.intl.formatMsg('Save')}</span>
						</Button>
					</PageHeader.Section>
				</PageHeader>
				<div className="container">
					<CodeEditor
						code={this.configurationContent}
						onChange={this.onContentChange}
						mode="javascript"
						lint
					/>
				</div>
				{ this.props.error && (
					<ErrorPage
						modal
						confirm
						className="lg error"
						errorDetail={this.props.errorDetail}
						onClose={this.props.closeErrorDialog}
						imgClass="gg icon-GG-cloud-cross"
					/>
				)}
				{ this.state.requestSaveConfirmation && (
					<ContentMessage
						confirm
						className="lg warning"
						title={this.intl.formatMsg('If your file is configured incorrectly you may encounter errors.')}
						detail={this.intl.formatMsg('Saving this file will automatically restart the server and all updated authorized credentails will need to be reauthorized.')}
						actionLabel={this.intl.formatMsg('Proceed')}
						cancelLabel={this.intl.formatMsg('Cancel')}
						onAction={() => this.confirm(true)}
						onClose={() => this.confirm(false)}
						imgClass="gg icon-GG-warning"
					/>
				)}
				{ this.props.saving && !this.props.error && (
					<ContentLoading inlineContent={false} message={this.intl.formatMsg('Saving')} />
				)}

			</div>
		);
	}
}

ConfigurationEditorView.propTypes = {
	item: PropTypes.object.isRequired,
	onCancel: PropTypes.func.isRequired,
	onSave: PropTypes.func.isRequired,
	saving: PropTypes.bool,
	error: PropTypes.bool,
	errorDetail: PropTypes.object,
	closeErrorDialog: PropTypes.func.isRequired
};

export default injectIntl(ConfigurationEditorView);
